<palantir-dialog title="SUPER DEBUG">
  <palantir-dialog-content class="palantir-scrollbar flex flex-col gap-4">
    @for (item of MENUS; track $index) {
      <div class="flex items-center justify-between rounded-md border border-solid p-2">
        <div class="flex flex-col gap-2">
          <palantir-text type="title" size="lg">{{ item.title }}</palantir-text>

          <palantir-text type="description" size="xs">{{ item.description }}</palantir-text>
        </div>

        <palantir-button
          theme="outline"
          size="xs"
          layout="suffix"
          variant="neutral"
          icon="hardware-outline"
          (click)="item.action()"
        >
          Executar
        </palantir-button>
      </div>
    }
  </palantir-dialog-content>
</palantir-dialog>
